import { h } from '@stencil/core';
import { tryParse } from '@pes-ui/utils';
export class CategoryHeading {
  constructor() {
    this.name = undefined;
    this.description = undefined;
    this.readMoreLabel = undefined;
    this.readLessLabel = undefined;
    this.badge = undefined;
    this.sdlImageBlock = undefined;
    this._name = undefined;
    this._description = undefined;
    this._readMoreLabel = undefined;
    this._readLessLabel = undefined;
    this._badge = undefined;
    this._sdlImageBlock = undefined;
    this.imageSourceSets = undefined;
  }
  componentWillLoad() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    this.name = (_a = tryParse(this._name)) !== null && _a !== void 0 ? _a : this.name;
    this.description = (_b = tryParse(this._description)) !== null && _b !== void 0 ? _b : this.description;
    this.readMoreLabel = (_c = tryParse(this._readMoreLabel)) !== null && _c !== void 0 ? _c : this.readMoreLabel;
    this.readLessLabel = (_d = tryParse(this._readLessLabel)) !== null && _d !== void 0 ? _d : this.readLessLabel;
    this.badge = (_e = tryParse(this._badge)) !== null && _e !== void 0 ? _e : this.badge;
    this.sdlImageBlock = (_f = tryParse(this._sdlImageBlock)) !== null && _f !== void 0 ? _f : this.sdlImageBlock;
    this.imageSourceSets = (_j = (_h = (_g = this.sdlImageBlock) === null || _g === void 0 ? void 0 : _g.image) === null || _h === void 0 ? void 0 : _h.imageSourceSets) !== null && _j !== void 0 ? _j : [];
    window.scrollTo(0, 0);
  }
  render() {
    return (h("header", { class: "category-header" }, this.sdlImageBlock && this.imageSourceSets.length > 0 ? (h("pes-category-banner", { name: this.name, description: this.description, readMoreLabel: this.readMoreLabel, readLessLabel: this.readLessLabel, imageSourceSets: this.imageSourceSets })) : (h("pes-category-description", { name: this.name, description: this.description, readMoreLabel: this.readMoreLabel, readLessLabel: this.readLessLabel, badge: this.badge, isCategory: true }))));
  }
  static get is() { return "pes-category-heading"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["category-heading.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["category-heading.css"]
    };
  }
  static get properties() {
    return {
      "name": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "header"
        },
        "attribute": "name",
        "reflect": false
      },
      "description": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "collapsible/expandable text"
        },
        "attribute": "description",
        "reflect": false
      },
      "readMoreLabel": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Label for \"Read more\""
        },
        "attribute": "read-more-label",
        "reflect": false
      },
      "readLessLabel": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Label for \"Read less\""
        },
        "attribute": "read-less-label",
        "reflect": false
      },
      "badge": {
        "type": "unknown",
        "mutable": true,
        "complexType": {
          "original": "TProductBadge | null",
          "resolved": "{ type: string; label: string; }",
          "references": {
            "TProductBadge": {
              "location": "import",
              "path": "../../category-subcategory-listing/types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "badge label config"
        }
      },
      "sdlImageBlock": {
        "type": "unknown",
        "mutable": true,
        "complexType": {
          "original": "SdlImageBlock",
          "resolved": "{ image?: { imageSourceSets?: ImageSourceSet[]; }; }",
          "references": {
            "SdlImageBlock": {
              "location": "import",
              "path": "../../category-subcategory-listing/types"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "Object with info about category banner"
        }
      },
      "_name": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-name",
        "reflect": false
      },
      "_description": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-description",
        "reflect": false
      },
      "_readMoreLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-read-more-label",
        "reflect": false
      },
      "_readLessLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-read-less-label",
        "reflect": false
      },
      "_badge": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-badge",
        "reflect": false
      },
      "_sdlImageBlock": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-sdl-image-block",
        "reflect": false
      }
    };
  }
  static get states() {
    return {
      "imageSourceSets": {}
    };
  }
}
